import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGripLines, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import "./kpiConfigAndPreviewItem.css";
import ConfigureKPI from "./ConfigureKPI/ConfigureKPI";
import {getDataFromConfig} from "../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKpiReviewServices"
import { InputFieldLengthValidationType } from "../../../../../features/salescodeStudio/mandatoryConfigs/manageKPIReview/manageKPIType";
interface KPIConfigAndPreviewItemProps {
  kpi: Record<string,any>;
  updateUserConfig: (_id:string,_kpi: Record<string, any>) => void;
  inputLengthValidation: InputFieldLengthValidationType,
  defaultConfigGlobal : Record<string,any>
}
function capitalizeSentence(sentence:string) {
  return sentence
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) 
    .join(" "); 
}
const KPIConfigAndPreviewItem: React.FC<KPIConfigAndPreviewItemProps> = ({
  kpi,  updateUserConfig,inputLengthValidation,defaultConfigGlobal 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };
  
  const title = getDataFromConfig("KPI_title",kpi?.id??"",defaultConfigGlobal);
  return (
   
    <div className="kpi-config-and-preview-item-container">
      <div
        className="kpi-config-and-preview-item-info-container"
        style={{
          borderRadius: isExpanded ? "5px 5px 0px 0px" : "5px",
          backgroundColor:isExpanded?"#f9fafc":"white",
          border:isExpanded?"none":undefined
        }}
      >
        <FontAwesomeIcon
          icon={faGripLines}
          className="kpi-config-and-preview-item-grab-icon"
        />
        <div className="kpi-config-and-preview-item-heading">{capitalizeSentence(title)}</div>
        <FontAwesomeIcon
          className="kpi-config-and-preview-item-expand-icon"
          icon={faChevronDown}
          onClick={toggleExpand}
          style={{
            transform: isExpanded ? "rotate(180deg)" : "none",
          
          }}
        />
      </div>
      {isExpanded && (
        <ConfigureKPI
          kpi={kpi}
          updateUserConfig={updateUserConfig}
          inputLengthValidation = {inputLengthValidation}
          defaultConfigGlobal={defaultConfigGlobal}
        />
      )}
    </div>
  );
};

export default KPIConfigAndPreviewItem;
